// extracted by mini-css-extract-plugin
var _1 = "FilePreviewDeleteButton-moduledeleteButton__H63y4";
export { _1 as "deleteButton" }
